/**
 * @generated SignedSource<<cfd2ba49ddcb1489294c33bb9ac45b30>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelPollUnsubscribeTaskQuery$variables = {
  id: string;
};
export type salesChannelPollUnsubscribeTaskQuery$data = {
  readonly productSwitcherTask: {
    readonly id: string;
    readonly lastError: string;
    readonly state: number;
    readonly taskID: number;
  } | null;
};
export type salesChannelPollUnsubscribeTaskQuery = {
  response: salesChannelPollUnsubscribeTaskQuery$data;
  variables: salesChannelPollUnsubscribeTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProductSwitcherTask",
    "kind": "LinkedField",
    "name": "productSwitcherTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastError",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelPollUnsubscribeTaskQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelPollUnsubscribeTaskQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "3fecdef692923be4384720f933098865",
    "id": null,
    "metadata": {},
    "name": "salesChannelPollUnsubscribeTaskQuery",
    "operationKind": "query",
    "text": "query salesChannelPollUnsubscribeTaskQuery(\n  $id: ID!\n) {\n  productSwitcherTask(id: $id) {\n    id\n    taskID\n    state\n    lastError\n  }\n}\n"
  }
};
})();

(node as any).hash = "011f9578582707f994ee5f353bca84aa";

export default node;
